import { memo } from 'react';
import { useTheme } from '@mui/material';
import SessionTimeoutIllustrationLight from './sessionTimeout.svg?react';
import SessionTimeoutIllustrationDark from './sessionTimeout_dark.svg?react';

export const SessionTimeoutIllustration = memo(
  (props: React.SVGProps<SVGSVGElement>) => {
    const theme = useTheme();

    if (theme.palette.type === 'dark')
      return <SessionTimeoutIllustrationDark aria-hidden="true" {...props} />;
    return <SessionTimeoutIllustrationLight aria-hidden="true" {...props} />;
  },
);
